import loadable from '@loadable/component';
import loadableModule from '../../loadable-module';

const SEOTextModule = loadableModule({
    LoadableComponent: loadable(() =>
        import(
            /* webpackChunkName: "seo-text" */
            './SEOText'
        )
    ),
    componentName: 'SEOText',
    placeholder: {
        placeholderType: 'Carousel',
        size: 'md',
    },
});
export default SEOTextModule;
